<template>
	<v-dialog v-model="openD" max-width="600" persistent>
		<v-card v-if="entrega">
			<v-card-title class="headline">
				<span v-html="heading"></span>
			</v-card-title>
			<v-container fluid grid-list-md v-if="result.estadoEntrega">
				<v-layout row wrap>
					<v-flex xs12>
						<label class="caption grey--text darken-3">Código de servicio / tecnología entregado</label>
						<span>
						<a @click="getDetalleTechnologi(entrega.TipoTec, entrega.CodSerTecEntregado)">{{entrega.TipoTec}} {{entrega.CodSerTecEntregado}}</a>
					</span>
					</v-flex>
					<v-flex xs12 sm12 md6>
						<label class="caption grey--text darken-3">Cantidad entregada</label>
						<span>{{entrega.CantTotEntregada}}</span>
					</v-flex>
					<v-flex xs12 sm12 md6 v-if="valorSerTecBase || valorSerTecBase === 0">
						<label class="caption grey--text darken-3">Precio unitario</label>
						<span>{{currency(valorSerTecBase)}}</span>
					</v-flex>
					<v-flex xs12>
						<v-text-field
								v-if="!valorSerTecBase"
								key="Valor"
								autofocus
								label="Valor entregado"
								v-model.number="result.ValorEntregado"
								name="Valor entregado"
								type="number"
								min="0"
								v-validate="'required|min_value:0|decimal:2'"
								:error-messages="errors.collect('Valor entregado')"
						>
						</v-text-field>
						<template v-else>
							<template v-if="editaPrecio === false">
								<label class="caption grey--text darken-3">Valor entregado</label>
								<span>
									{{valorSerTec || valorSerTec === 0 ? currency(valorSerTec) : '$ _'}}
									<v-tooltip top>
										<v-btn slot="activator" class="mx-0 mt-0" icon small @click="editaPrecio = true">
											<v-icon color="orange" small>fas fa-pen</v-icon>
										</v-btn>
										<span>Editar valor entregado</span>
									</v-tooltip>
								</span>
							</template>
							<v-text-field
									v-if="editaPrecio === true"
									key="Valor"
									autofocus
									label="Valor entregado"
									v-model.number="result.ValorEntregado"
									name="Valor entregado"
									type="number"
									min="0"
									v-validate="'required|min_value:0|decimal:2'"
									:error-messages="errors.collect('Valor entregado')"
							>
								<template v-slot:append-outer>
									<v-tooltip top>
										<v-btn class="mt-0" slot="activator" icon @click="editaPrecio = false">
											<v-icon color="primary">fas fa-reply-all</v-icon>
										</v-btn>
										<span>Cancelar edición del valor entregado</span>
									</v-tooltip>
								</template>
							</v-text-field>
						</template>
					</v-flex>
				</v-layout>
			</v-container>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
						@click="close"
						:disabled="load"
				>
					Cancelar
				</v-btn>
				<v-btn
						color="primary"
						:loading="load"
						:disabled="load"
						@click="submit"
				>
					Reportar
				</v-btn>
			</v-card-actions>
		</v-card>
		<detail-technologi-dialog ref="dialogInfoTechnologi" @onProcess="load = false"></detail-technologi-dialog>
	</v-dialog>
</template>

<script>
export default {
  	props: ['heading'],
    data: () => ({
        openD: false,
        load: false,
		editaPrecio: false,
		valorSerTecBase: null,
        entrega: null,
        result: {
            entrega_id: null,
            ValorEntregado: null,
            estadoEntrega: 1
		}
	}),
	watch: {
		valorSerTec (val) {
			this.result.ValorEntregado = val
		},
		'editaPrecio' (val) {
			if (!val) {
				this.result.ValorEntregado = this.valorSerTec
			}
		},
		'result.estadoEntrega' (val) {
		  !val && (this.result.ValorEntregado = null)
		}
	},
	computed: {
		valorSerTec () {
			if (this && (this.valorSerTecBase || this.valorSerTecBase === 0) && (Number(this.entrega.CantTotEntregada) || Number(this.entrega.CantTotEntregada) === 0)) {
				return  (this.valorSerTecBase * Number(this.entrega.CantTotEntregada))
			}
			return null
		}
	},
	methods: {
		getDetalleTechnologi (type, code) {
			this.load = true
			this.$refs.dialogInfoTechnologi.getDetail(type, code)
		},
        submit () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.loading()
					          this.result.entrega_id = this.entrega.id
                    const data = JSON.parse(JSON.stringify(this.result))
                    data.ValorEntregado = this.valorDecimal(this.result.ValorEntregado)
                    this.axios.post(`reporteEntregas`, data)
                        .then((response) => {
                            this.$store.commit('snackbar', {color: 'success', message: `El reporte de la entrega No. ${this.entrega.id} se registró correctamente`})
                            this.$store.commit('reloadTable', 'tableReportesEntrega')
                            this.$store.commit('reloadTable', 'tableEntregas')
                            this.close()
                        }).catch(e => {
                        this.loading(false)
                        this.$store.commit('snackbar', {color: 'error', message: `al registrar el reporte de la entrega No. ${this.entrega.id}`, error: e})
                    })
                }
            })
        },
		getPrecio () {
			this.axios.get(`precios/consultar?TipoTec=${this.entrega.TipoTec}&CodSerTec=${this.entrega.CodSerTecEntregado}`)
					.then(response => {
						this.valorSerTecBase = response.data || null
					}).catch(e => {
				this.$store.commit('snackbar', {color: 'error', message: `al traer el precio del servicio/tecnología ${this.entrega.TipoTec} ${this.entrega.CodSerTecEntregado}.`, error: e})
			})
		},
		open (entrega) {
            this.entrega = entrega
			this.getPrecio()
			this.result.estadoEntrega = this.entrega.CausaNoEntrega ? 0 : 1
		  	this.openD = true
		},
		loading (val = true) {
		  this.load = val
		},
		close () {
		  	this.openD = false
			setTimeout(() => {
                this.load = false
                this.result.entrega_id = null
				this.result.ValorEntregado = null
				this.result.estadoEntrega = 1

				this.editaPrecio = false
				this.valorSerTecBase = null
                this.$validator.reset()
			}, 300)
		}
  	}
}
</script>

